<div class="d-flex justify-content-between" [ngClass]="{'disableDiv': isReactionBarDisabled}">
        <div *ngFor="let url of emojiArray; index as i;" (click)="create(i)">
            <img [src] = "url.location" style="width: 48px; height: 48px" class="cursor-pointer">
        </div>
</div>
<div *ngIf="showAnimation">
    <app-reaction-animation (animationEnd)="endAnimation($event)" [emojiIndex]="emojiIndex" (reloadAnimation)="animate" [startPosition]="startPosition" [emojiUrl]="emojiUrl"  [emojiCount]="5"></app-reaction-animation>
</div>
